import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlaceService from "../../services/place.service";

/* =================== Thunks =================== */

export const getPlace = createAsyncThunk(
  "place/getPlace",
  async (params, thunkAPI) => {
    try {
      const response = await PlaceService.getPlace(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addPlace = createAsyncThunk(
  "place/addPlace",
  async (data, thunkAPI) => {
    try {
      const response = await PlaceService.addPlace(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatePlace = createAsyncThunk(
  "place/updatePlace",
  async (payload, thunkAPI) => {
    try {
      const response = await PlaceService.editPlace(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deletePlace = createAsyncThunk(
  "place/deletePlace",
  async (id, thunkAPI) => {
    try {
      await PlaceService.deletePlace(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  placeList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const placeSlice = createSlice({
  name: "place",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlace.fulfilled, (state, action) => {
        state.loading = false;
        state.placeList = action.payload?.places || [];
      })
      .addCase(getPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPlace.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.places ||
          action.payload;

        if (newHotel) {
          state.placeList.unshift(newHotel);
        }
      })
      .addCase(addPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updatePlace.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updatePlace.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.places;

        if (updated?._id) {
          const index = state.placeList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.placeList[index] = updated;
          }
        }
      })
      .addCase(updatePlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deletePlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlace.fulfilled, (state, action) => {
        state.loading = false;
        state.placeList = state.placeList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deletePlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = placeSlice.actions;
export default placeSlice.reducer;
